import Navbar from "./Navbar";
import { IQProfilePic, resumeDownload, resumeDownloadIcon, contact, cursorIrfan } from "../assets/index";
import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { db } from "../firebase-config";
import { getDocs, collection } from "firebase/firestore";
import { useRef } from "react";

function Profile() {
  const IndustryCollectionRef = collection(db, "Industry");
  const [industryInfo, setIndustryInfo] = useState([]);
  const dialogRef = useRef();
  useEffect(() => {
    const industryData = async () => {
      const data = await getDocs(IndustryCollectionRef);
      setIndustryInfo(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    industryData();
  }, []);
  function closeDialog() {
    dialogRef.current?.close();
  }
  return (
    <>
      <dialog ref={dialogRef}>
        <span onClick={closeDialog} className="closeDialog"></span>
        <div className="Popup">
          <div className="content">
            <div className="profile">
              <img
              className="profile-img"
              src={IQProfilePic}
              alt=""
              title="Irfan Qureshi"
            />
            </div>
            <div className="table">
              <span className="available"><span className="status status-green"></span>Available</span>
              <h4>Muhammad Irfan Qureshi</h4>
              <p className="email">qureshi.mirfan@gmail.com</p>
              <p className="phone">+60104352980</p>
              <div><span className="tag">Freelance</span><span className="tag">UI/UX</span><span className="tag">Front-end</span></div>
            </div>
          </div>
        </div>
      </dialog>
      <motion.div className="box left iq-sticky"
      initial={{ opacity: 0}}
      animate={{ opacity: 1}}
      transition={{ duration: 0.75, ease: "easeOut"}}
      >
        <img className="cursorIrfan" src={cursorIrfan} />
        <div className="profile">
          <img
            className="profile-img"
            src={IQProfilePic}
            alt=""
            title="Irfan Qureshi"
          />
          <span className="available"><span className="status status-green"></span>Available</span>
          <span className="contact" onClick={()=> dialogRef.current?.showModal()}><img src={contact} /></span>
        </div>
        <div className="desc">
          <h4>Muhammad Irfan Qureshi <span><a href={resumeDownload} download title="Download Resume"><img src={resumeDownloadIcon} /></a></span></h4>
          <p className="bio">UX Lead | Digital Thinker | UX Unicorn</p>
          <p>
            👋, I’m a UI/UX Designer with a passion for creating intuitive and
            engaging digital experiences.
          </p>
          
          {industryInfo ? industryInfo.map((industry, index)=> {
            const sortedSectors = industry.Sectors.sort((a, b) => a.localeCompare(b));
            return(
              <>
                <div className="chips" key={industry.id}>                  
                  {sortedSectors.map((sector)=>{
                    return (
                      <span>{sector}</span>
                    )
                  })}
                </div>
              </>
            )
          }): ""}
        </div>
        <Navbar />
      </motion.div>
    </>
  );
}

export default Profile;
